import { useApi } from '@src/app/context/Api';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';

/**
 * Hook: useAssets
 *
 * Makes API requests to retrieve the assets required for the current experience.
 *
 * @param theAssets
 * @returns {{assets: {}, isLoadingAssets: boolean}}
 */
export const useAssets = (theAssets = []) => {
  const { useApiQueries } = useApi();
  const assets = useApiQueries(theAssets);

  // Compute loading state directly from assets
  const isLoadingAssets = useMemo(() => {
    return (
      isEmpty(assets) ||
      Object.keys(assets).length !== theAssets.length ||
      !isEmpty(
        Object.keys(assets).filter((assetKey) => {
          const asset = assets[assetKey];
          return asset?.isLoading || asset?.isFetching;
        })
      )
    );
  }, [assets, theAssets]);

  return useMemo(() => {
    return { assets, isLoadingAssets };
  }, [assets, isLoadingAssets]);
};
